export function convertToSnakeCase(string: string) {
  const normalized = string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
  return (
    normalized.charAt(0).toLowerCase() +
    normalized
      .slice(1) // lowercase the first character
      .replace(/\W+/g, " ") // Remove all excess white space and replace & , . etc.
      .replace(/([a-z])([A-Z])([a-z])/g, "$1 $2$3") // Put a space at the position of a camelCase -> camel Case
      .split(/\B(?=[A-Z]{2,})/) // Now split the multi-uppercases customerID -> customer,ID
      .join(" ") // And join back with spaces.
      .split(" ") // Split all the spaces again, this time we're fully converted
      .join("_") // And finally snake_case things up
      .toLowerCase()
  ); // With a nice lower case
}

export function isChildOfPreviousHeader(
  headerTagPrev: string,
  headerTagNext: string
) {
  return (
    Number(headerTagPrev.replace("H", "")) >
    Number(headerTagNext.replace("H", ""))
  );
}

export function isEqualOfPreviousHeader(
  headerTagPrev: string,
  headerTagNext: string
) {
  return (
    Number(headerTagPrev.replace("H", "")) ===
    Number(headerTagNext.replace("H", ""))
  );
}

export interface IBlogSection {
  hash: string;
  title: string;
  type: string;
  children: IBlogSection[];
}

export function checkSection(
  newSection: IBlogSection,
  sections: IBlogSection[]
) {
  if (sections.length === 0 || newSection.type === sections[0].type)
    sections.push(newSection);
  else {
    const lastSection = [...sections].pop();
    checkSection(newSection, lastSection!.children);
  }
  return sections;
}
